export const Style = ({ colors = [] }) => (
  <g id="Estilo2_4_">
    <linearGradient
      id="SVGID_189_"
      gradientUnits="userSpaceOnUse"
      x1="74.9664"
      y1="404.9366"
      x2="74.9664"
      y2="458.408"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_189_)' }}
      d="M55.9,69.9c0,0-1-12.5,10.6-16.9c11.6-4.4,18.3-7.7,18.8-16.3 c0,0,3.6,7.5,0,12.6c0,0,4.3,0.2,5.1-2.7c0,0,1.7,4.8,1,6.4c0,0,2.2-0.2,2.4-3.3l1.4,16.4l1,3.7l3.5-11.6c0,0,9.2-21.6-10.3-27.2 c0,0-16.4-14.1-33.4,2.1c0,0-13.8,10.9-4.5,27.9L55.9,69.9z"
    />

    <linearGradient
      id="SVGID_190_"
      gradientUnits="userSpaceOnUse"
      x1="48.58"
      y1="444.9495"
      x2="89.19"
      y2="444.9495"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
      <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
      <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
      <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
      <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
    </linearGradient>
    <path
      style={{
        opacity: '0.6',
        fill: 'url(#SVGID_190_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M55.8,33.1c0,0-5.4,4.3-7.2,11.7 c1.8-3,7.9-12,17.4-14.8C77.5,26.5,89.2,31,89.2,31S72.8,16.9,55.8,33.1z"
    />

    <linearGradient
      id="SVGID_191_"
      gradientUnits="userSpaceOnUse"
      x1="89.19"
      y1="439.565"
      x2="101.6463"
      y2="439.565"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
      <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
      <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
      <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
      <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
    </linearGradient>
    <path
      style={{
        opacity: '0.6',
        fill: 'url(#SVGID_191_)',
        enableBackground: 'new',
        mixBlendMode: 'multiply'
      }}
      d="M101.5,49.9L101.5,49.9 c0.7-6.7-0.8-15.5-12.3-18.9C89.2,31,101.9,38.9,101.5,49.9z"
    />

    <linearGradient
      id="SVGID_192_"
      gradientUnits="userSpaceOnUse"
      x1="61.77"
      y1="424.5291"
      x2="71.94"
      y2="424.5291"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_192_)' }}
      d="M61.8,58c0,0,6.8-2.2,10.2-2c0,0-0.6-3.7-4.6-3.1 C62.5,53.8,61.8,58,61.8,58z"
    />

    <linearGradient
      id="SVGID_193_"
      gradientUnits="userSpaceOnUse"
      x1="80.02"
      y1="425.8831"
      x2="90.36"
      y2="425.8831"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_193_)' }}
      d="M90.4,56.3c0,0-7-1.4-10.3-0.8c0,0,0.1-3.8,4.2-3.6 C89.1,52.1,90.4,56.3,90.4,56.3z"
    />
  </g>
)

export const Back = ({ colors = [] }) => <></>

Style.Back = Back
